import { useState, useEffect, useCallback } from 'react';
import { Player } from '../types/game';
import { getTopRankings, saveRanking } from '../utils/scoreCalculator';
import { generatePlayerId } from '../utils/gameLogic';

export const useRanking = () => {
  const [rankings, setRankings] = useState<Player[]>([]);
  const [loading, setLoading] = useState(true);
  
  const loadRankings = useCallback(() => {
    setLoading(true);
    const topRankings = getTopRankings(10);
    setRankings(topRankings);
    setLoading(false);
  }, []);
  
  const savePlayerScore = useCallback((name: string, reactionTime: number, score: number) => {
    const player: Player = {
      id: generatePlayerId(),
      name,
      reactionTime,
      score,
      timestamp: Date.now(),
    };
    
    saveRanking(player);
    loadRankings();
  }, [loadRankings]);
  
  useEffect(() => {
    loadRankings();
  }, [loadRankings]);
  
  return {
    rankings,
    loading,
    savePlayerScore,
    refreshRankings: loadRankings,
  };
};